import { render, staticRenderFns } from "./OpenClose.vue?vue&type=template&id=6463756d"
import script from "./OpenClose.vue?vue&type=script&lang=js"
export * from "./OpenClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports